<template>
  <div class="alt-logo" :class="{ 'is-light': light }" role="img" aria-label="ALT GROUP company">
    <svg class="alt-logo__mark" viewBox="0 0 390 205" aria-hidden="true">
      <defs>
        <linearGradient id="altGold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#f0d27c" />
          <stop offset="60%" stop-color="#d9b65a" />
          <stop offset="100%" stop-color="#b8923a" />
        </linearGradient>
        <linearGradient id="altShine" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stop-color="#fff" stop-opacity="0" />
          <stop offset="50%" stop-color="#fff" stop-opacity=".75" />
          <stop offset="100%" stop-color="#fff" stop-opacity="0" />
        </linearGradient>
        <clipPath id="altMarkClip">
          <polygon points="98,123 225,12 225,123" />
          <polygon points="17,197 58,159 210,159 210,197" />
          <polygon transform="translate(236,8) skewX(-9)" points="0,0 140,0 140,34 40,34 40,156 100,156 100,112 70,112 70,80 140,80 140,190 0,190" />
        </clipPath>
      </defs>
      <polygon class="alt-logo__tri" points="98,123 225,12 225,123" fill="url(#altGold)" />
      <polygon class="alt-logo__bar" points="17,197 58,159 210,159 210,197" fill="url(#altGold)" />
      <polygon class="alt-logo__g" transform="translate(236,8) skewX(-9)"
               points="0,0 140,0 140,34 40,34 40,156 100,156 100,112 70,112 70,80 140,80 140,190 0,190" />
      <g clip-path="url(#altMarkClip)">
        <rect class="alt-logo__shine" x="-160" y="-20" width="120" height="250" fill="url(#altShine)" />
      </g>
    </svg>
    <div class="alt-logo__word">
      <span class="alt-logo__name">
        <span v-for="(ch, i) in 'ALT'" :key="'a' + i" class="alt-logo__ch alt-logo__ch--gold" :style="{ '--i': i }">{{ ch }}</span>
        <span class="alt-logo__gap"></span>
        <span v-for="(ch, i) in 'GROUP'" :key="'g' + i" class="alt-logo__ch" :style="{ '--i': i + 3 }">{{ ch }}</span>
      </span>
      <span class="alt-logo__company">company</span>
    </div>
  </div>
</template>

<script setup>
// Логотип ALT GROUP — векторный, с анимацией появления и бликом (решение Анны 02.11.2026).
defineProps({ light: { type: Boolean, default: false } })
</script>

<style scoped>
.alt-logo { --grey: #e6e7ea; display: inline-flex; align-items: center; gap: 14px; perspective: 600px; }
.alt-logo.is-light { --grey: #666769; }
.alt-logo__mark { width: 74px; height: auto; overflow: visible; transform-style: preserve-3d;
  animation: alt-float 6s ease-in-out 1.6s infinite; filter: drop-shadow(0 6px 14px rgba(217, 182, 90, .35)); }
.alt-logo__tri { animation: alt-tri .9s cubic-bezier(.2, .9, .2, 1.15) backwards; transform-origin: 225px 123px; }
.alt-logo__bar { animation: alt-bar .8s cubic-bezier(.2, .8, .2, 1) .25s backwards; }
.alt-logo__g { fill: var(--grey); animation: alt-g .9s cubic-bezier(.3, 1.4, .4, 1) .45s backwards; }
.alt-logo__shine { animation: alt-shine 5.5s ease-in-out 1.8s infinite; }
.alt-logo__word { display: flex; flex-direction: column; line-height: 1; }
.alt-logo__name { display: inline-flex; font: italic 900 30px/1 'Arial Black', 'Helvetica Neue', Arial, sans-serif;
  letter-spacing: -.02em; color: var(--grey); }
.alt-logo__gap { width: .32em; }
.alt-logo__ch { display: inline-block; animation: alt-ch .6s cubic-bezier(.2, .9, .3, 1.3) backwards;
  animation-delay: calc(.6s + var(--i) * 55ms); }
.alt-logo__ch--gold { background: linear-gradient(100deg, #b8923a 0%, #f0d27c 35%, #fff3c4 50%, #f0d27c 65%, #b8923a 100%);
  background-size: 300% 100%; -webkit-background-clip: text; background-clip: text; color: transparent;
  animation: alt-ch .6s cubic-bezier(.2, .9, .3, 1.3) backwards, alt-gold 4s linear 1.6s infinite;
  animation-delay: calc(.6s + var(--i) * 55ms), 1.6s; }
.alt-logo__company { margin: 4px 0 0 3.2em; font: 300 13px/1 'Segoe UI', Roboto, sans-serif; letter-spacing: .14em;
  color: #9aa0ad; animation: alt-fade 1s ease 1.2s backwards; }

@keyframes alt-tri { from { opacity: 0; transform: translateX(-60px) rotateY(70deg); } }
@keyframes alt-bar { from { opacity: 0; transform: translateX(-90px); } }
@keyframes alt-g { from { opacity: 0; transform: translate(236px, -60px) skewX(-9deg); } }
@keyframes alt-shine { 0% { transform: translateX(0); } 35%, 100% { transform: translateX(620px); } }
@keyframes alt-float { 0%, 100% { transform: rotateY(0) translateY(0); } 50% { transform: rotateY(14deg) translateY(-3px); } }
@keyframes alt-ch { from { opacity: 0; transform: translateY(14px) skewX(-12deg); } }
@keyframes alt-gold { from { background-position: 100% 0; } to { background-position: -200% 0; } }
@keyframes alt-fade { from { opacity: 0; letter-spacing: .5em; } }
@media (prefers-reduced-motion: reduce) {
  .alt-logo *, .alt-logo { animation: none !important; }
}
</style>
